import { render, staticRenderFns } from "./NewMachines.vue?vue&type=template&id=240f075a&scoped=true&"
import script from "./NewMachines.vue?vue&type=script&lang=js&"
export * from "./NewMachines.vue?vue&type=script&lang=js&"
import style0 from "./NewMachines.vue?vue&type=style&index=0&id=240f075a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240f075a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VDataTable,VIcon,VSpacer,VToolbarTitle})
